import React, { useState, useEffect } from 'react';
import API_BASE from '../config';

function WorkCard({ item }) {
    return (
        <div className="group relative bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100 hover:shadow-2xl transition-all duration-300">
            <div className="aspect-[4/3] overflow-hidden">
                <img
                    src={item.image_url || 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80'}
                    alt={item.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <span className="text-[#2E63E8] text-xs font-bold uppercase tracking-wider mb-2">{item.project_type || 'Residential'}</span>
                <h3 className="text-white font-bold text-lg leading-tight">{item.name}</h3>
            </div>
            <div className="p-4 bg-white group-hover:hidden">
                <p className="text-gray-800 font-semibold text-sm line-clamp-1">{item.name}</p>
            </div>
        </div>
    );
}

export default function OurWorks() {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetch(`${API_BASE}/projects.php`)
            .then(r => r.json())
            .then(data => {
                if (data.status === 'success' && data.projects) {
                    setProjects(data.projects.slice(0, 6));
                }
            })
            .catch(() => {});
    }, []);

    // Fallback to empty or static if no projects in DB yet
    if (projects.length === 0) return null;

    return (
        <section className="section-pad bg-white" id="our-works">
            <div className="max-w-7xl mx-auto px-4">
                <div className="text-center mb-12">
                    <p className="text-[#2E63E8] font-semibold uppercase tracking-widest text-sm mb-2">Portfolio</p>
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Featured Works</h2>
                    <div className="w-20 h-1 bg-[#2E63E8] mx-auto rounded-full"></div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {projects.map((item, i) => (
                        <WorkCard key={item.id || i} item={item} />
                    ))}
                </div>
                <div className="text-center mt-12">
                    <a href="/projects" className="btn-yellow inline-block px-8 py-3 text-sm">View All Projects →</a>
                </div>
            </div>
        </section>
    );
}

